export default __webpack_public_path__ + "static/media/Prototipo.46290249.png";